module.exports = __webpack_public_path__ + "img/EXTERIOR-BALENO-2.99051a2d.jpg";